import { DataService } from './../services/data.service';
import {
  BellStatus,
  ConfigStatus,
  RingPattern,
  RingPatterns,
} from './../constants/constants';
import { CradleService } from '../services/cradle.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CradleCommands } from '../constants/constants';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Utils } from '../constants/utils';
import { MatRippleModule } from '@angular/material/core';
import { environment } from '../../environment/environment';
import { NotificationBarComponent } from '../notification-bar/notification-bar.component';
import { LockButtonComponent } from '../lock-button/lock-button.component';
import { RouterModule } from '@angular/router';
import { RingBtnComponent } from "./ring-btn/ring-btn.component";

const PER_PAGE_ACTIONS = 9;

@Component({
    selector: 'app-ring-functions',
    imports: [
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSliderModule,
    MatInputModule,
    FormsModule,
    MatExpansionModule,
    CommonModule,
    MatInputModule,
    MatCheckboxModule,
    MatCardModule,
    MatRippleModule,
    RouterModule,
    NotificationBarComponent,
    LockButtonComponent,
    RingBtnComponent
],
    templateUrl: './ring-functions.component.html',
    styleUrl: './ring-functions.component.scss'
})
export class RingFunctionsComponent implements OnInit, OnDestroy {
  isController: boolean = environment.isController;
  isCradleOnline: boolean = false;
  bellStatus: BellStatus = new BellStatus();
  subscriptions: Subscription[] = [];
  public CradleCommands = CradleCommands;
  ringInterval: number = 1;
  ringInterval2: number = 1;
  hasSecondaryInterval: boolean = false;
  ringCount: number = 1;
  ringPatternsDict:RingPatterns;
  ringPatterns: RingPattern[] = [];
  paginatedRingPatterns: RingPattern[] = [];
  currentPage: number = 0;
  lastPage: number = null;
  configs: ConfigStatus;



  constructor(
    private snackBar: MatSnackBar,
    public cradleService: CradleService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.dataService.bellStatus.subscribe((status) => {
        if (status !=null ){
          this.bellStatus = status;
          if (!this.isCradleOnline) {
            this.isCradleOnline = true;
            this.snackBar.open('Bell is online', 'Ok', { duration: 1000 });
          }
        }
      })
    );
    this.subscriptions.push(
      this.dataService.ringPatterns.subscribe(
        (ringPatterns) => {
          if (ringPatterns) {
            this.ringPatternsDict = ringPatterns;
            this.ringPatterns = Utils.dictToList(ringPatterns)
            if(this.isController){
              this.paginateRingPatterns();
            } else {
              this.paginatedRingPatterns = this.ringPatterns;
            }
          }
        }
      )
    );


    // this.refreshScreen();
  }

  fetchRingPatterns() {
    this.cradleService.dispatchCommand(CradleCommands.GET_RING_PATTERNS);
  }

  refreshScreen() {
    this.cradleService.dispatchCommand(CradleCommands.PUBLISH_CURRENT_STATUS);
    this.fetchRingPatterns();
  }

  formatLabel(value: number): string {
    return `${value} s`;
  }

  dispatchAction(command: CradleCommands, value: any) {
    this.cradleService.dispatchCommand(command, value);
  }

  onPagePrevious(){
    if(this.currentPage>0){
      this.currentPage -=1;
    }
    this.paginateRingPatterns();
  }

  onPageNext(){
    if(this.currentPage<this.lastPage){
      this.currentPage +=1;
    }
    this.paginateRingPatterns();
  }

  paginateRingPatterns(){
    const startIndex = this.currentPage * PER_PAGE_ACTIONS;
    const endIndex = this.currentPage * PER_PAGE_ACTIONS + PER_PAGE_ACTIONS;
    this.paginatedRingPatterns = this.ringPatterns.slice(startIndex, endIndex);
    this.lastPage = Math.ceil(this.ringPatterns.length/PER_PAGE_ACTIONS) - 1;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
